import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { ContentModule } from 'app/layout/components/content/content.module';
import { QuickPanelModule } from 'app/layout/components/quick-panel/quick-panel.module';
import { VerticalLayoutComponent } from 'app/layout/vertical/layout.component';

@NgModule({
  declarations: [
    VerticalLayoutComponent
  ],
  imports: [
    RouterModule,
    FuseSharedModule,
    FuseSidebarModule,
    ContentModule,
    QuickPanelModule,
  ],
  exports: [
    VerticalLayoutComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class VerticalLayoutModule {
}
